import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import NavBar from '@/components/navbar/NavBar';
import { AuthProvider } from '@/context/AuthContext';
import CommonLayout from '@/components/layout/CommonLayout';

export default function Root() {
	return (
		<>
			<AuthProvider>
				{/* <NavBar /> */}
				<CommonLayout>
				<div id="pages" className="flex flex-col flex-1 mt-[64px] ml-[250px]">
					<Outlet />
				</div>
				</CommonLayout>
			</AuthProvider>
			<div data-test="toast-container">
				<ToastContainer data-test="toast-container" />
			</div>
		</>
	);
}
